module.exports = __webpack_public_path__ + "img/icon_fire_on.e7318eb5.png";